import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { Trans, withTranslation } from "react-i18next";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import CoreFilter from "../../components/filter/CoreFilter";
import Button from "@material-ui/core/Button";
import { withLastLocation } from "react-router-last-location";
import { Badge } from "@material-ui/core";

const styles = (theme) => ({
  popper: {
    zIndex: 1,
    minWidth: 500,
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: "-0.9em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "0 1em 1em 1em",
        borderColor: `transparent transparent ${
          theme.palette.common.white
        } transparent`,
      },
    },
  },
  arrow: {
    position: "absolute",
    fontSize: 7,
    width: "3em",
    height: "3em",
    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  taxonomyNodePicker: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
  chipInput: {
    maxWidth: 150,
  },
  formWrapper: {
    display: "flex",
    flexWrap: "wrap",
  },
  mainFilters: {
    marginBottom: theme.spacing(5),
  },
  inlineFilters: {
    display: "flex",
  },
  container: {},
});
const StyledBadge = withStyles((theme) => ({
  anchorOriginTopLeftRectangle: {
    transform: "translate(-150%, 50%)",
  },
  badge: {
    // left: -8,
    // top: 13,
    // border: `2px solid ${theme.palette.background.paper}`,
    // padding: '0 4px',
  },
}))(Badge);
const equal = require("deep-equal");
const areObjectsEqual = (obj1, obj2) => {
  return equal(obj1, obj2) ? true : false;
};
export class FilterTopics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: { attached: "All" },
      defaultFilter: { attached: "All" },
    };
  }

  handleArrowRef = (node) => {
    this.setState({
      arrowRef: node,
    });
  };
  isFilterSet = (filter) => {
    const isSet = this.state.defaultFilter.hasOwnProperty(filter)
      ? Object.keys(this.props.filter).length === 0
        ? false
        : !areObjectsEqual(
            this.state.defaultFilter[filter],
            this.props.filter[filter]
          )
      : true;
    return isSet;
  };
  handleSelectChange = (event) => {
    this.setState(
      {
        filter: {
          ...this.state.filter,
          [event.target.name]: event.target.value,
        },
      },
      () => this.onFilterChange()
    );
  };
  onFilterChange = () => {
    let filter = Object.assign({}, this.state.filter);
    this.props.onFilterChange(filter);
  };

  handleClick = (e) => {
    this.props.resetToDefaultFilters(this.state.defaultFilter);
  };
  render() {
    const { classes, t } = this.props;
    return (
      <div
        className={
          this.props.asPopper ? classes.container : classes.inlineFilters
        }
      >
        {this.props.showReset(this.state.defaultFilter) === true && (
          <Button className={classes.resetButton} onClick={this.handleClick}>
            <Trans i18nKey="global_clear" />
          </Button>
        )}
        <div
          className={
            this.props.asPopper ? classes.mainFilters : classes.inlineFilters
          }
        >
          {this.props.currentUser.userPermits.roles.systemManager && (
            <FormControl className={classes.formControl}>
              {this.isFilterSet("attached") && (
                <StyledBadge
                  color="secondary"
                  variant="dot"
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                />
              )}
              <InputLabel htmlFor="attached">
                <Trans i18nKey="global_attached" />
              </InputLabel>
              <Select
                value={
                  this.props.filter.attached
                    ? this.props.filter.attached
                    : this.state.defaultFilter.attached
                }
                onChange={this.handleSelectChange}
                inputProps={{
                  name: "attached",
                  id: "attached",
                }}
              >
                <MenuItem value={"All"}>
                  <Trans i18nKey="global_all" />
                </MenuItem>
                <MenuItem value={"Attached"}>
                  <Trans i18nKey="attached_only" />
                </MenuItem>
                <MenuItem value={"Unattached"}>
                  <Trans i18nKey="unattached_only" />
                </MenuItem>
              </Select>
            </FormControl>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});

const mapDispatchToProps = {
  // setFilters,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withStyles(styles)(
    withTranslation()(withLastLocation(CoreFilter(FilterTopics)))
  )
);
